/* eslint-disable */
/* eslint-disable @typescript-eslint/naming-convention */
import axios from "axios";
import useCookie from "../hooks/useCookie";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import { handleAxiosError } from "./errorHandler";

axios.defaults.baseURL = `${process.env.REACT_APP_ONLINE_URL}/api/v1`;
const userData = getLocalStorage(dataLocalStorage.userinfo);

axios.interceptors.request.use(
  async (config) => {
    const cookie = useCookie();
    const accessToken = userData?.token;
    const guestUuid = cookie.getCookie("guest_uuid");
    if (accessToken) {
      config.headers = {
        ...config.headers,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        token: accessToken,
      };
    }
    if (guestUuid) {
      config.headers = {
        ...config.headers,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "guest-uuid": guestUuid,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    handleAxiosError(error?.response?.data?.message);
    return Promise.reject(error);
  }
);

export const axiosPrivate = axios;
